import React from "react";
import NewLoginCreateAccount from "../../new-login-create-account/NewLoginCreateAccount.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../store/userSlice";
import { User } from "../types/user";
import styled from "@emotion/styled";

const LoginContainer = styled.div`
  width: 90vw;

  @media (min-width: 768px) {
    width: 75vw;
  }

  &.bsl-login .login-ca__form {
    .login-ca__header.login-ca__head {
      @media (min-width: 768px) {
        font-size: 24px;
      }
    }
    .login-ca__button.login-ca__continue-button.action,
    .form-control,
    .login-ca__button.login-ca__continue-button.action {
      @media (min-width: 768px) {
        font-size: 20px !important;
      }
    }
  }

  &.bsl-login:has(.react-tel-input.phone-input)
    .login-ca__header.login-ca__head::after,
  &.bsl-login .login-ca__subhead {
    @media (min-width: 768px) {
      font-size: 18px !important;
    }
  }

  &.bsl-login .login-ca__form .login-ca__container .login-ca__error,
  &.bsl-login .login-ca__form .error,
  &.bsl-login
    .login-ca__container
    .input-error-col:not(.mg-checkbox)
    .outline
    input:not([type="tel"]):focus-within
    ~ label,
  &.bsl-login
    .login-ca__container
    .input-error-col:not(.mg-checkbox)
    .outline
    input:not([type="tel"]):not(:placeholder-shown)
    ~ label,
  &.bsl-login
    .login-ca__container
    .input-error-col:not(.mg-checkbox)
    .floating-label-input.login-ca__disabled-field
    ~ label,
  &.bsl-login
    .login-ca__container
    .input-error-col:not(.mg-checkbox)
    .floating-label-wrapper
    input:not([type="tel"]):focus-visible
    ~ label {
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
`;

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  return (
    <LoginContainer className="bsl-login">
      <NewLoginCreateAccount
        country="US"
        isBslCheckout={true}
        setUser={(user: User) => {
          dispatch(setUser(user));
          if (location.search?.includes("location_id=")) {
            navigate(`/diner-selection${location.search}`);
          } else {
            navigate(`/location-selection`);
          }
        }}
        siteArea={"managers_web"}
      />
    </LoginContainer>
  );
};

export default Login;
